export const parseJSON = (string, id) => {
  try {
    return JSON.parse(string)
  } catch (e) {
    console.error(`${e.message} on ${id}`)
    return {}
  }
}

export const hasExpression = (string) => {
  try {
    return JSON.parse(string).hasOwnProperty('exp')
  } catch (e) {
    return false
  }
}
